import { groupBy as _groupBy } from "ramda";

export function groupBy<T>(
  list: ReadonlyArray<T>,
  fn: (a: T) => string
): { [index: string]: Array<T> } {
  return _groupBy(fn, list);
}
